import { ConsoleLogger, LogLevel } from 'amazon-chime-sdk-js'
import {
  GlobalStyles,
  LoggerProvider,
  MeetingProvider,
  NotificationGroup,
  NotificationProvider,
  UserActivityProvider,
  lightTheme
} from 'amazon-chime-sdk-component-library-react'
import { PropsWithChildren, useMemo } from 'react'
import { ThemeProvider } from 'styled-components'

import { ChimeObservabilityProvider } from '@hooks/useChimeObservability'

export function ChimeProvider({ children }: PropsWithChildren) {
  const logger = useMemo(() => new ConsoleLogger('chime-ui', LogLevel.WARN), [])

  return (
    <LoggerProvider logger={logger}>
      <MeetingProvider>
        <ChimeObservabilityProvider />

        <ThemeProvider theme={lightTheme}>
          <NotificationProvider>
            <UserActivityProvider>
              <GlobalStyles />
              <NotificationGroup />
              {children}
            </UserActivityProvider>
          </NotificationProvider>
        </ThemeProvider>
      </MeetingProvider>
    </LoggerProvider>
  )
}
